export default __webpack_public_path__ + "static/media/item-3-safari-14.03464705.png";